{
  "branding": {
    "frontdesk-attribution": "Powered by FrontDesk+",
    "practice-logo": "{{name}} logo"
  },
  "validation": {
    "required": "This field is required",
    "invalid-url": "Please enter a valid URL",
    "pin-too-short": "PIN must be at least 4 characters",
    "pin-default-rejected": "The standard PIN 0000 is not allowed. Please assign your own PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Back",
    "next": "Next",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "done": "Done",
    "retry": "Retry",
    "clear": "Clear",
    "close": "Close",
    "verifying": "Verifying...",
    "select": "Select",
    "minutes": "minutes",
    "clock": "",
    "gender": {
      "M": "Male",
      "W": "Female",
      "D": "Diverse",
      "U": "Unknown"
    },
    "insurance": {
      "GKV": "Statutory",
      "PKV": "Private",
      "SELFPAY": "Self-pay"
    },
    "scroll-up": "Scroll up",
    "scroll-down": "Scroll down"
  },
  "settings": {
    "device-reset": {
      "title": "Reset device",
      "description": "Remove this device’s practice connection, device settings and PIN.",
      "confirmation": "This device will need to be set up again. SOL configuration and patient data in inSuite remain unchanged.",
      "cancel": "Cancel",
      "confirm": "Reset now"
    },
    "title": "Settings",
    "save": "Save",
    "save-success": "Settings saved",
    "save-error": "Failed to save settings",
    "load-error": "Failed to load settings",
    "pin": {
      "title": "PIN Required",
      "description": "Please enter your PIN to open the settings.",
      "error": "Wrong PIN. Please try again.",
      "backspace": "Delete last digit"
    },
    "connection": {
      "title": "Connection",
      "description": "Connection to the practice's Doc Cirrus Bridge",
      "bridge-url": "Bridge address",
      "device-name": "Device Name",
      "device-name-placeholder": "e.g. Reception, Room 1, Kiosk",
      "device-name-hint": "This device appears under this name in the Bridge overview.",
      "kim-address": "KIM Address (optional)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Connection successful",
      "error": "Connection failed",
      "api-unreachable": "DocCirrus API unreachable",
      "status-title": "Connection Status",
      "status": {
        "api": "API connected",
        "ti": "Telematics infrastructure",
        "card-reader": "Card reader available",
        "medical-card": "Practice card (SMC-B/HBA)"
      },
      "kim-address-consequence": "For check-in by QR code, this address receives the insurer's insurance data instead of the practice address.",
      "kim-address-practice": "Practice address (default)",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "For check-in by QR code, the health insurer will send the insurance data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol token (from inSuite)",
      "sol-token-hint": "Copy it from the Bridge administration in inSuite. Required for the connection.",
      "sol-token-show": "Show token",
      "sol-token-hide": "Hide token",
      "bridge-unreachable": "Bridge not reachable. Please check the address and port.",
      "diagnostic-id": "Diagnostic ID: {{id}}",
      "scan-qr": "Scan QR code",
      "scan-title": "Scan Bridge QR code",
      "scan-manual": "Enter manually"
    },
    "terminal": {
      "title": "Card reader",
      "description": "Card reader for the health insurance card on this device",
      "select": "Card reader",
      "select-placeholder": "Choose card reader",
      "loading": "Loading card readers …",
      "none-available": "No card readers available",
      "none-found": "No card readers found",
      "found": "{{count}} terminal(s) found",
      "connect-hint": "Test the connection first to load the card readers.",
      "found-count": "Card readers found: {{count}}",
      "refresh": "Reload card readers"
    },
    "practice": {
      "title": "Practice",
      "description": "Information about your practice",
      "name": "Practice Name",
      "name-placeholder": "e.g. Dr. John Smith",
      "welcome-message": "Welcome Message",
      "welcome-placeholder": "e.g. Welcome to our practice",
      "scheduler-available": "Enable Scheduler",
      "scheduler-available-description": "Allow patients to book appointments through the self-service terminal",
      "prescription-available": "Enable Prescription Service",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Leave empty to greet patients in their own language. Your own text is shown unchanged in every language."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Saved for all devices on {{value}}",
      "never-saved-default": "Default setting, not changed yet."
    },
    "anamnesis": {
      "title": "Digital Medical History",
      "description": "Shows a link and QR code to your medical history provider after check-in.",
      "enabled": "Show medical history link after check-in",
      "enabled-description": "Shows a link and QR code to your medical history provider after a completed check-in, for example Nelly.",
      "url": "Medical history provider link",
      "url-hint": "The link is static and identical for all patients.",
      "preview-label": "Completion-screen preview",
      "preview-note": "The link is static and identical for all patients.",
      "url-first": "Enter a valid link first to switch this on."
    },
    "appearance": {
      "title": "Appearance",
      "description": "Customize the user interface",
      "language": "Language",
      "default-kiosk-language": "Default Patient Language",
      "default-kiosk-language-hint": "Language that new kiosk sessions start in for patients.",
      "voice-over-volume": "Voice-Over Volume",
      "voice-over-hint": "Controls the volume of the voice-over assistant for accessibility.",
      "language-first": "Show language selection at session start"
    },
    "security": {
      "title": "Security",
      "description": "PIN for accessing settings",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Kiosk administration",
    "nav": {
      "general": "General",
      "flows": "Features",
      "anamnese": "Digital medical history",
      "device": "Device & connection"
    },
    "flows": {
      "title": "Features on the terminal"
    },
    "language": {
      "title": "Language & speech",
      "description": "Language and read-aloud for patients on this device."
    }
  },
  "self-service": {
    "title": "Self-Service",
    "step-progress": "Step {{current}} / {{total}}",
    "flows": {
      "checkin": "Check-in",
      "scheduler": "Book Appointment",
      "prescription": "Prescriptions",
      "locations": "Location Map",
      "emergency": "Emergency"
    },
    "audio-guide": {
      "on": "Sound on",
      "off": "Sound off",
      "replay": "Replay guidance",
      "replay-unavailable": "No guidance available to replay"
    },
    "language-selector": {
      "title": "Select Language",
      "description": "Please select your preferred language"
    },
    "settings": "Settings",
    "start": {
      "welcome": "Welcome",
      "subtitle": "Please select an option",
      "check-in-label": "Main path",
      "check-in-cta": "Check-in",
      "check-in-description": "Already have an appointment? Check in here.",
      "check-in-hint": "Have your card ready",
      "scheduler-label": "New",
      "scheduler-cta": "Book Appointment",
      "scheduler-description": "Schedule a new appointment.",
      "location-plan": "Location Map",
      "location-plan-description": "Find your way to the treatment room.",
      "prescription-label": "Prescription",
      "prescription-cta": "Prescriptions & Ordering",
      "prescription-description": "View prescriptions or order refills.",
      "emergency-cta": "Local Emergency Alert",
      "emergency-description": "Audible only on this device — does not summon help.",
      "tap-to-start": "Tap to start"
    },
    "offline": {
      "banner-title": "Check-in temporarily unavailable",
      "banner-message": "Please speak with reception staff for assistance.",
      "emergency-available": "The local alert remains available. It does not summon help.",
      "flow-disabled": "Temporarily unavailable"
    },
    "readability": {
      "toggle-label": "Reading mode",
      "on": "Reading mode",
      "off": "Reading mode"
    },
    "reset-overlay": {
      "timeout-title": "Session ended",
      "timeout-subtitle": "Your time has expired. Your data is safe.",
      "offline-title": "Connection lost",
      "offline-subtitle": "The connection was interrupted. Please speak with reception staff.",
      "interruption-title": "Session ended",
      "interruption-subtitle": "Your session has been safely ended.",
      "completion-title": "Thank you!",
      "completion-subtitle": "Your request has been completed successfully.",
      "reassurance": "Your personal data is not stored on this device.",
      "auto-dismiss": "Returning to start in {{seconds}} seconds...",
      "dismiss": "Go to start"
    },
    "timed-terminal": {
      "countdown": "Automatic return in {{seconds}} seconds",
      "countdown-outcome": "This terminal will automatically return to the start screen.",
      "more-time": "More time",
      "extended": "Time extended"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "These questions are not available in your language. Please choose an offered language or contact reception.",
        "alternatives": "Alternative appointments",
        "loading": "Loading questions…",
        "reception-fallback": "Please go to the reception.",
        "error-title": "The questions could not be loaded",
        "language-unavailable-lead": "These questions are not available in your language.",
        "language-unavailable-title": "Please choose one of these languages",
        "language-unavailable-body": "Or ask for help at the reception."
      },
      "start": {
        "title": "Book Appointment",
        "subtitle": "Book your preferred appointment in a few steps",
        "welcome": "Welcome to Appointment Booking",
        "description": "We will guide you through the booking process",
        "cta": "Book appointment now"
      },
      "patient-id": {
        "title": "Identification",
        "subtitle": "Please identify yourself",
        "mode-card": "With card",
        "mode-search": "Search",
        "mode-create": "Create new",
        "insert-card": "Please insert your insurance card",
        "reading-card": "Reading card...",
        "simulate-card": "Simulate card",
        "multiple-matches": "Multiple patients found. Using card data.",
        "search-placeholder": "Name or insurance number...",
        "searching": "Searching...",
        "no-results": "No results found",
        "first-name": "First name",
        "last-name": "Last name",
        "dob": "Date of birth",
        "insurance": "Insurance",
        "continue": "Continue",
        "creating": "Creating patient...",
        "patient-created": "Patient created successfully!",
        "create-error": "Could not create the patient."
      },
      "appointment-type": {
        "title": "Select Appointment Type",
        "subtitle": "Please select the reason for your visit",
        "loading": "Loading appointment types...",
        "no-types": "No appointment types available",
        "no-bookable": "These appointment types cannot currently be booked at the kiosk. Please contact reception or schedule by phone.",
        "disabled-default": "Please schedule this appointment directly at reception or by phone.",
        "disabled-footer": "Reception/phone only",
        "error": "Could not load appointment types. Please try again.",
        "lead": "What kind of appointment would you like to book?",
        "duration": "approx. {{minutes}} minutes",
        "empty-title": "Appointments cannot be booked here right now",
        "none-bookable-title": "You cannot book these appointments here",
        "none-bookable-body": "Please ask at the reception or give us a call."
      },
      "types": {
        "general": "General Consultation",
        "general-desc": "For general complaints and questions",
        "checkup": "Preventive Checkup",
        "checkup-desc": "Regular health checks",
        "vaccination": "Vaccination",
        "vaccination-desc": "Schedule a vaccination",
        "followup": "Follow-up",
        "followup-desc": "Control appointment",
        "prescription": "Prescription",
        "prescription-desc": "Prescription pickup"
      },
      "slot-selection": {
        "title": "Select Appointment",
        "subtitle": "Please select an available appointment",
        "loading": "Loading available appointments...",
        "no-slots": "No available appointments",
        "no-appointment-type": "No appointment type selected",
        "error": "Could not load available slots. Please try again.",
        "quick-select": "Next available appointments:",
        "select-date": "Or select a date:",
        "times-for": "{{date}}",
        "available": "Available",
        "unavailable": "No slots",
        "slots": "slots",
        "select-time-hint": "Tap a time to book your appointment",
        "week-short": "Wk",
        "weekday-mon": "Mon",
        "weekday-tue": "Tue",
        "weekday-wed": "Wed",
        "weekday-thu": "Thu",
        "weekday-fri": "Fri",
        "weekday-sat": "Sat",
        "weekday-sun": "Sun",
        "period-morning": "Morning",
        "period-midday": "Midday",
        "period-afternoon": "Afternoon",
        "period-evening": "Evening",
        "period-morning-short": "AM",
        "period-midday-short": "Noon",
        "period-afternoon-short": "PM",
        "period-evening-short": "Eve",
        "period-dots-legend": "Time availability",
        "filter-hint": "Filter by preferred times:",
        "or-choose-below": "or choose below",
        "no-slots-period": "No slots",
        "show-all": "Show all",
        "free": "free",
        "your-selection": "Your selection",
        "oclock": "o'clock",
        "choose-slot": "Choose slot",
        "choose-day": "Choose a day",
        "choose-day-first": "Please choose a day first",
        "times-heading": "Free times on {{date}}",
        "time-value": "{{time}}",
        "empty-title": "No free appointments in {{month}}",
        "empty-body": "Look at the next month or ask at the reception – we are happy to help.",
        "next-month": "Next month",
        "previous-month": "Previous month"
      },
      "confirmation": {
        "patient-responses": "Your responses",
        "review-loading": "Checking summary…",
        "review-unavailable": "Summary not available. Please try again or ask at the reception.",
        "check-booking": "Check booking status",
        "title": "Confirm Appointment",
        "subtitle": "Please review your booking",
        "patient": "Patient",
        "datetime": "Date and time",
        "booking": "Booking...",
        "confirm": "Book appointment",
        "heading": "Does this look right?",
        "lead": "Please confirm your appointment.",
        "appointment": "Appointment",
        "insured-via": "Insured through",
        "description-label": "Notes for the practice (optional)",
        "description-hint": "Tell us if there is anything we should consider for scheduling or check-in.",
        "description-placeholder": "e.g. limited mobility, accompanying person, important notes",
        "description-too-long": "Please keep the note to 500 characters or fewer.",
        "summary": "Summary",
        "change": "Change",
        "book-binding": "Book appointment",
        "cancel": "Cancel",
        "type-label": "Type of appointment",
        "datetime-value": "{{date}} at {{time}}",
        "name-label": "Full name",
        "insurance-label": "Insurance",
        "insurance-GKV": "Statutory health insurance",
        "insurance-PKV": "Private health insurance",
        "insurance-SELFPAY": "Self-payer",
        "change-time": "Change appointment",
        "description-free-text": "Other notes (optional)",
        "note-wheelchair": "I use a wheelchair",
        "note-companion": "Someone is coming with me",
        "note-interpreter": "I need an interpreter"
      },
      "done": {
        "title": "Appointment Booked!",
        "label": "Booked",
        "subtitle": "Your appointment has been successfully booked.",
        "date": "Date",
        "time": "Time",
        "booking-id": "Booking number",
        "qr-hint": "Add to your calendar",
        "qr-description": "Scan this QR code with your smartphone camera to add the appointment to your calendar app",
        "auto-redirect": "You will be redirected to the start page shortly...",
        "auto-redirect-countdown": "Returning to start in {{seconds}} seconds...",
        "back-to-start": "Back to start",
        "print-button": "Print appointment slip",
        "print-preparing": "Preparing print view…",
        "print-error": "The appointment slip could not be opened. Please try again or ask reception for help.",
        "print-returned": "The system print view was closed. You may request another copy if needed.",
        "print-title": "Your appointment",
        "print-location": "Location",
        "print-map-hint": "Open the location on your phone",
        "print-error-v2": "The appointment slip could not be opened. Please try again or ask at the reception."
      },
      "error": {
        "assistance-info": "We could not confirm your booking. Your appointment may already be booked. Please ask at the reception.",
        "pending-title": "Booking not confirmed",
        "pending-info": "We could not confirm your booking. Your appointment may already be booked. Please check again or ask at the reception.",
        "title": "Booking Failed",
        "subtitle": "The appointment could not be booked.",
        "info": "Please try again or ask at the reception."
      },
      "phase": {
        "identify": "Sign in",
        "choose": "Choose time",
        "confirm": "Confirm"
      }
    },
    "prescription": {
      "start": {
        "title": "Prescriptions & Ordering",
        "subtitle": "Insert your insurance card to view prescriptions or order refills.",
        "button": "Insert Card"
      },
      "card-check": {
        "loading": "Loading card reader...",
        "no-terminal": "No card reader configured",
        "no-terminal-hint": "Please contact staff for assistance.",
        "insert-card": "Please insert your card",
        "insert-card-hint": "Insert your insurance card into the card reader.",
        "card-detected": "Card detected",
        "reading": "Reading card...",
        "reading-hint": "Please wait a moment.",
        "error": "Error reading card",
        "retry": "Try again",
        "manual-lookup": "Continue without card",
        "load-error": "Could not load card reader",
        "read-error": "The card could not be read"
      },
      "patient-selection": {
        "title": "Select Patient",
        "subtitle": "Multiple patients were found. Please select your name.",
        "try-again": "Try again",
        "try-again-hint": "Insert card again"
      },
      "list": {
        "title": "Your Prescriptions",
        "for-patient": "Prescriptions for {{name}}",
        "loading": "Loading prescriptions...",
        "error-title": "Loading Error",
        "fetch-error": "Prescriptions could not be loaded",
        "back-home": "Back to Start",
        "done": "Done"
      },
      "detail": {
        "prescription-info": "Prescription Information",
        "date": "Date",
        "prescriber": "Prescriber",
        "comment": "Note",
        "medications": "Medications",
        "form": "Form",
        "pack-size": "Pack Size",
        "manufacturer": "Manufacturer",
        "loading": "Loading prescription...",
        "fetch-error": "Prescription details could not be loaded",
        "back-to-list": "Back to List",
        "print": "Print"
      },
      "types": {
        "public": "Public Prescription",
        "private": "Private Prescription",
        "long-term": "Long-Term Prescription",
        "btm": "Narcotic Prescription",
        "g": "Green Prescription",
        "t": "T-Prescription"
      },
      "no-patient": {
        "title": "Patient Not Found",
        "subtitle": "Unfortunately, no patient was found for this card. Please contact staff for assistance.",
        "try-again": "Try Again",
        "back-home": "Back to Start",
        "title-v2": "No matching details found",
        "subtitle-v2": "We could not find you. Please try again or ask at the reception."
      },
      "done": {
        "title": "Thank You",
        "subtitle": "You may take a seat now. If you have questions, please contact staff.",
        "no-prescriptions-title": "No prescriptions on file",
        "no-prescriptions-subtitle": "We couldn’t find any active prescriptions for you. If you expected one, please contact reception staff.",
        "error-title": "An Error Occurred",
        "error-subtitle": "Please contact staff for further assistance.",
        "auto-redirect": "Automatic redirect in {{seconds}} seconds",
        "finish": "Back to Start"
      },
      "hub": {
        "title": "Your Prescriptions",
        "for-patient": "Prescriptions for {{name}}",
        "loading": "Loading prescriptions...",
        "error-title": "Loading Error",
        "fetch-error": "Could not load prescriptions",
        "back-home": "Back to Start",
        "done": "Done",
        "order-button": "Order Prescription",
        "existing-prescriptions": "Your current prescriptions",
        "no-prescriptions": "No active prescriptions found."
      },
      "patient-lookup": {
        "title": "Find Patient",
        "subtitle": "Enter your name and date of birth.",
        "last-name": "Last Name",
        "first-name": "First Name",
        "date-of-birth": "Date of Birth",
        "lastname": "Last Name",
        "lastname-placeholder": "Your last name",
        "firstname": "First Name",
        "firstname-placeholder": "Your first name",
        "dob": "Date of Birth",
        "search": "Search",
        "searching": "Searching...",
        "search-error": "Search error: {{message}}",
        "no-match": "No patient found. Please check your information.",
        "error": "Search error. Please try again.",
        "found": "Patient found",
        "confirm": "Confirm",
        "ambiguous": "Multiple matches",
        "ambiguous-hint-firstname": "Please also enter your first name to refine the search.",
        "ambiguous-hint-additional": "Please check your information or contact staff.",
        "not-found": "Patient not found",
        "not-found-hint": "No patient could be found with these details.",
        "not-found-action": "Try again"
      },
      "manual-identification": {
        "unverified": "Your identity was not confirmed with the insurance card. The practice will verify your details and request before processing it."
      },
      "medication-selection": {
        "title": "Request a prescription",
        "subtitle": "The practice reviews your request. Once approved, the eRx is ready in your e-prescription app.",
        "back": "Back",
        "submit": "Continue to review",
        "reason-title": "Why do you need the prescription?",
        "reason-hint": "Helps the practice assess your request.",
        "reason-validation": "Please choose a reason.",
        "reason-schmerzen": "Pain",
        "reason-entzuendung": "Inflammation",
        "reason-nachsorge": "After surgery / procedure",
        "reason-allergie": "Allergy / reaction",
        "reason-chronisch": "Chronic condition",
        "reason-anderes": "Something else",
        "medications-title": "Which medications?",
        "request-hint": "Describe what you need, or name the previous prescription you want renewed.",
        "request-placeholder": "e.g. Ibuprofen 600 mg, same as last time",
        "request-validation": "Please describe which medication you need.",
        "history-title": "Previous prescriptions",
        "history-hint": "Add an entry to prefill your request.",
        "history-loading": "Loading previous prescriptions...",
        "history-error": "Previous prescriptions could not be loaded.",
        "history-add": "Add",
        "history-added": "Added",
        "history-date": "Last: {{date}}",
        "history-request-line": "Renew: {{medicationName}}",
        "urgency-title": "How urgent is it?",
        "urgency-hint": "Helps the practice prioritise.",
        "urgency-soon": "Urgent",
        "urgency-soon-meta": "As soon as possible",
        "urgency-tomorrow": "Soon",
        "urgency-tomorrow-meta": "In the next few days",
        "urgency-week": "This week",
        "urgency-week-meta": "No time pressure",
        "lead": "The practice reviews your request. Once approved, you will find your e-prescription in the e-prescription app or on your health insurance card.",
        "history-hint-v2": "Tap an earlier prescription to add it.",
        "history-retry": "Load again"
      },
      "request-review": {
        "title": "Review Order",
        "subtitle": "Please review your prescription request.",
        "request-label": "Requested medication",
        "selected-medications": "Selected Medications",
        "free-text-medications": "Additional Medications",
        "freetext-label": "Other",
        "quarterly-warning": "Your insurance card has not been read this quarter. The practice may contact you.",
        "egk-warning": "Your insurance card has not been read this quarter. The practice may contact you.",
        "submit": "Submit",
        "submitting": "Submitting...",
        "submit-error": "Could not submit the request. Please try again.",
        "egk-proof-required": "Prescription requests are only available after a successful insurance card read. Please contact staff.",
        "back": "Back",
        "reason-label": "Reason",
        "urgency-label": "Urgency",
        "completion-email-choice": "I would like an email when the practice has processed my request.",
        "completion-email-label": "Email address",
        "completion-email-placeholder": "name@example.com",
        "completion-email-hint": "Only for this one-time message. The address is not saved as master data.",
        "completion-email-invalid": "Please enter a valid email address.",
        "title-v2": "Review request",
        "completion-email-hint-v2": "The address is used only for this one message."
      },
      "confirmation": {
        "title": "Request Sent",
        "subtitle": "Your prescription request has been submitted successfully.",
        "success-title": "Request Sent",
        "success-subtitle": "Your prescription request has been submitted successfully.",
        "estimated-time": "Your prescription will be ready in approximately {{time}}.",
        "info": "You can pick up your prescription at the pharmacy with your insurance card or the eRezept app.",
        "auto-redirect": "Automatic redirect in {{seconds}} seconds",
        "back-to-start": "Back to Start",
        "handling-label": "Handled by the practice",
        "next-steps": "The practice reviews your request. Once approved, you can redeem your e-prescription at the pharmacy with your health insurance card or the e-prescription app."
      },
      "phase": {
        "identify": "Sign in",
        "request": "Request",
        "review": "Review"
      }
    },
    "check-in": {
      "flow-label": "Check-in",
      "has-appointment": {
        "eyebrow": "Appointment",
        "title": "Do you have an appointment?",
        "subtitle": "Please select an option",
        "yes-label": "Yes",
        "yes": "Yes, I have an appointment",
        "yes-description": "I want to check in for my appointment.",
        "yes-hint": "Fastest path",
        "unsure-label": "Maybe",
        "unsure": "I'm not sure",
        "unsure-description": "We'll check that for you.",
        "unsure-hint": "We'll search for you",
        "no-label": "No",
        "no": "No, walk-in",
        "no-description": "I don't have an appointment.",
        "no-hint": "Walk-in"
      },
      "card-check": {
        "eyebrow": "Insurance card",
        "title": "Read Insurance Card",
        "subtitle": "Please insert your insurance card into the reader",
        "insert-title": "Insert your insurance card into the reader.",
        "insert-detail": "We read your details automatically — you do not need to do anything else.",
        "other-ways": "Other ways",
        "no-card-hint": "If you do not have your card with you right now.",
        "pkv-hint": "Use the QR code with your insurance app.",
        "loading": "Loading settings...",
        "no-terminal": "No card reader configured. Please contact staff.",
        "checking": "Checking for cards...",
        "insert-prompt": "Please insert card...",
        "card-detected": "Card detected! Ready to read.",
        "read-card": "Read Card",
        "simulate-insert": "Simulate card",
        "reading": "Reading card...",
        "error": "Could not read card. Please try again.",
        "read-error": "Failed to read card data. Please try again.",
        "settings-error": "Could not load settings. Please try again.",
        "no-card-prompt": "No card with you?",
        "no-card-action": "Manual search",
        "connection-warning": "Connection issues with card reader. Please wait...",
        "pkv-prompt": "Private insurance? Online Check-in",
        "pkv-instruction": "Scan this QR code with your private health insurance app to transmit your data digitally.",
        "pkv-continue": "Continue to manual registration",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Please try again or sign in without a card. Reception will be glad to help.",
        "title-pkv": "Sign in with the app",
        "title-reading": "Reading your card …",
        "title-unreadable": "Card could not be read",
        "title-no-terminal": "Sign in without a card",
        "no-terminal-body": "The card reader is not available right now. Please sign in without a card or ask at reception.",
        "reading-detail": "Please leave the card in the reader. This only takes a moment.",
        "other-ways-title": "Other options",
        "no-card-title": "Sign in without a card",
        "pkv-prompt-title": "Privately insured?",
        "pkv-prompt-hint": "Sign in with your private health insurance app",
        "pkv-close": "Use my card after all",
        "pkv-instruction-app": "Open your private health insurance app and scan this code. Your details are then sent straight to us."
      },
      "patient-selection": {
        "title": "Identification Required",
        "subtitle": "Multiple patients found. Please enter your first name so we can identify you.",
        "firstname-label": "Your first name",
        "firstname-placeholder": "Enter first name...",
        "confirm-button": "Confirm",
        "no-match": "No matching patient found. Please go to the reception desk for assistance.",
        "still-ambiguous": "Multiple matches remain. Please go to the reception desk for assistance.",
        "select-error": "Failed to identify patient. Please try again.",
        "staff-assist": "Go to reception",
        "title-v2": "Quick question",
        "subtitle-v2": "For your security, please enter your first name.",
        "no-match-v2": "We could not find you with this first name. Please check the spelling or ask at reception.",
        "still-ambiguous-v2": "We could not identify you clearly yet. Please ask at reception.",
        "select-error-v2": "Something went wrong. Please try again."
      },
      "card-checkin": {
        "title": "Confirm Check-in",
        "subtitle": "Your data was successfully read.",
        "confirm": "Confirm check-in"
      },
      "register-from-card": {
        "title": "New Registration",
        "subtitle": "We've read your data from the card. Please review and confirm your registration.",
        "card-data": "Card Data",
        "create": "Register Patient",
        "create-error": "Registration failed. Please try again or ask staff for assistance.",
        "staff-assist": "Call Staff",
        "no-card-data-title": "No Card Data",
        "no-card-data": "Unable to read data from your card.",
        "insurance-verified": "Insurance verified: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Your details from the card",
        "subtitle-v2": "Please check your details. If something is wrong, tap \"Change\".",
        "create-v2": "Confirm details",
        "create-error-v2": "Sign-in did not work. Please try again or ask at reception.",
        "insurer-missing-v2": "Your card does not show your health insurer. Please ask at reception.",
        "edit": "Change",
        "name": "Full name",
        "insurer": "Health insurer"
      },
      "patient-lookup": {
        "title": "Search Patient",
        "subtitle": "Please enter your name or insurance number.",
        "lastname": "Last name",
        "lastname-placeholder": "Your last name",
        "dob": "Date of birth",
        "firstname": "First name",
        "firstname-placeholder": "Your first name",
        "search": "Search",
        "searching": "Searching...",
        "search-placeholder": "Name or insurance number...",
        "results-placeholder": "Search results will appear here",
        "found": "Patient found!",
        "confirm-identity": "Please confirm that you are the patient shown.",
        "confirm-button": "That's me",
        "ambiguous-firstname": "Multiple patients were found. Please enter your first name.",
        "ambiguous-additional": "Multiple patients were found. Please contact staff.",
        "disambiguation-hint": "This helps us identify you clearly.",
        "not-found": "No patient was found with these details.",
        "error": "Search error: {{message}}",
        "staff-assist": "Call staff",
        "not-found-prompt": "Not found?",
        "register-new": "Register new",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Sign in without a card",
        "subtitle-firstname": "Please also enter your first name.",
        "ambiguous-firstname-v2": "There are several people with this name. Please also enter your first name.",
        "search-again": "Search again",
        "found-v2": "We found you",
        "found-confirm": "Please confirm with \"That's me\".",
        "not-found-title": "We could not find you",
        "not-found-check": "Please check the spelling and your date of birth. Reception will be glad to help.",
        "not-found-reception": "Please check the spelling and your date of birth, or ask at reception.",
        "ambiguous-additional-v2": "We could not identify you clearly. Please ask at reception.",
        "error-v2": "The search did not work just now. Please try again."
      },
      "checking-in": {
        "title": "One moment — we are checking you in.",
        "subtitle": "We are adding you to the treatment queue and notifying the team.",
        "step-insurance": "Insurance checked",
        "step-appointment": "Appointment confirmed",
        "step-waitlist": "Adding to waiting list",
        "error": "Check-in failed. Please try again.",
        "continue": "Continue anyway",
        "title-v2": "One moment please",
        "loading": "Signing you in …",
        "subtitle-v2": "We are adding you to the waiting list and letting the team know.",
        "error-title": "Something went wrong",
        "error-v2": "Your sign-in could not be completed.",
        "error-body": "Please try again. If it still does not work, reception will help you."
      },
      "appointment-selection": {
        "title": "Select appointment",
        "subtitle": "You have several appointments today. Please choose one.",
        "checking-in": "Checking in...",
        "time": "{{time}}",
        "error-v2": "Sign-in for this appointment did not work. Please try again or ask at reception."
      },
      "no-appointment": {
        "title": "No appointment found",
        "subtitle": "We could not find an appointment for you today. Please book a regular appointment.",
        "book-appointment": "Book appointment",
        "book-appointment-description": "Book a new appointment through the regular scheduler.",
        "staff-assist": "Call staff",
        "staff-assist-description": "I need assistance.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "We could not find an appointment for you today.",
        "book-v2": "Book a new appointment",
        "book-v2-description": "Choose a free appointment now.",
        "have-appointment": "I have an appointment",
        "have-appointment-description": "Reception will be glad to help.",
        "unavailable-title": "Please book appointments at reception",
        "subtitle-unavailable": "We could not find an appointment for you today. Please ask at reception."
      },
      "staff-assist": {
        "title": "Staff notified",
        "subtitle": "A staff member will assist you shortly.",
        "message": "Please wait here. A staff member will be with you shortly.",
        "start-over": "Back to start",
        "auto-redirect": "Returning to start in {{seconds}} seconds..."
      },
      "eeb-prompt": {
        "title": "Verify Insurance",
        "title-failed": "Verification Failed",
        "subtitle": "How would you like to verify your insurance?",
        "subtitle-failed": "Scan the QR code with your insurance app to request verification.",
        "verify-card": "Verify electronically",
        "verify-card-description": "Send a request to your insurance provider.",
        "select-insurer": "Select insurer",
        "select-insurer-description": "Manual selection of your insurer.",
        "skip": "Skip",
        "eyebrow-chip": "Alternative",
        "eyebrow": "Check-in · proof of insurance (eEB)",
        "recommended": "Recommended",
        "qr-title": "Scan with your insurance app",
        "qr-description": "Open your health insurance app and scan the code — the eEB is sent directly to us.",
        "qr-address-label": "Send to",
        "title-app": "Proof via app",
        "subtitle-app": "Your health insurer can also send us the proof directly. When you are done, tap \"Next\"."
      },
      "quarterly-check": {
        "title": "Insurance Verification",
        "checking": "We are checking your current insurance verification...",
        "error": "The check could not be performed.",
        "title-v2": "Your insurance",
        "checking-v2": "We are checking your insurance – one moment please.",
        "error-body": "Your sign-in is complete. Reception will sort out your insurance with you."
      },
      "insurer-prefilled": {
        "title": "Your Health Insurance",
        "subtitle": "Please confirm your insurance for this quarter.",
        "your-insurance": "Your insurance",
        "last-read": "Last verified on {{date}}",
        "quarterly-notice": "For billing purposes, we need current proof of insurance for this quarter.",
        "confirm-button": "Yes, this is my insurance",
        "change-button": "I have different insurance",
        "contact-title": "Request Electronic Proof of Coverage",
        "contact-description": "Call your insurance and request an electronic proof of coverage for:",
        "contact-patient": "Patient",
        "contact-kim-address": "Practice KIM address",
        "contact-phone": "Phone",
        "question": "Is this your health insurer?",
        "quarterly-notice-v2": "Once per quarter we need proof from your health insurer."
      },
      "insurer-search": {
        "title": "Select Health Insurance",
        "subtitle": "Please search and select your statutory health insurance.",
        "placeholder": "Search insurance...",
        "hint": "Enter at least 2 characters to search.",
        "no-results": "No insurance found.",
        "no-results-hint": "Check the spelling or try a different search.",
        "label": "Name of your health insurer",
        "search-error-v2": "The search did not work just now. Please try again.",
        "app-alternative": "Prefer to use your health insurer's app?"
      },
      "insurer-contact": {
        "title": "Request Proof of Insurance",
        "subtitle": "Please choose one of the following options.",
        "or": "or",
        "option-eeb-title": "Request electronically",
        "option-eeb-description": "If the statutory exception applies, you can hand the request to the practice team after giving your consent.",
        "option-qr-title": "Scan with app",
        "option-qr-description": "Scan the QR code with your insurance app.",
        "option-call-title": "Call yourself",
        "option-call-description": "Call your insurance and request an eEB for this practice:",
        "phone": "Phone",
        "phone-not-available": "Phone number on your insurance card",
        "patient-name": "Patient",
        "practice-kim": "Practice KIM address",
        "help-notice": "If you have any problems, please visit the reception desk.",
        "submit-eeb-button": "Request now",
        "contacted-button": "I have called",
        "contacted-button-countdown": "Time for your call ({{seconds}}s)",
        "go-to-counter-button": "Go to reception",
        "qr-continue-button": "I have scanned",
        "qr-continue-button-countdown": "Time to scan ({{seconds}}s)",
        "title-v2": "Proof from your health insurer",
        "subtitle-v2": "The easiest way is with your health insurer's app.",
        "subtitle-no-app": "Please choose how your health insurer should send us the proof.",
        "option-eeb-description-v2": "We contact your health insurer for you. For this we need your consent.",
        "call-instruction": "Call your health insurer and ask them to send the proof to our practice.",
        "call-instruction-practice": "Call your health insurer and ask them to send the proof to the practice {{practice}}.",
        "done-button": "Done – next",
        "done-button-countdown": "Done – next (another {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Consent",
        "subtitle": "We need your consent for electronic insurance verification.",
        "insurance": "Your insurance",
        "consent-title": "Consent for Electronic Insurance Verification (eEB)",
        "consent-text": "I understand that my health insurance will transmit my insurance data (e.g., name, date of birth, insurance number) via the secure KIM communication service to the practice {{practiceName}} as proof of insurance. I consent to this transmission. I am aware that I can revoke this consent at any time without affecting my treatment.",
        "withdrawal-notice": "You can revoke this consent at any time.",
        "agree-button": "I agree",
        "decline-button": "Cancel",
        "treatment-notice": "Your treatment is not affected by this consent.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Proof from your health insurer",
        "summary": "Your health insurer sends us the proof directly. For this we need your consent.",
        "confirm-first": "Please confirm the declaration first."
      },
      "qr-code": {
        "title": "Scan with insurance app",
        "instruction-1": "Open your insurance app and scan this QR code.",
        "instruction-2": "The practice will then automatically receive your insurance verification.",
        "practice": "Practice: {{name}}",
        "alternative-hint": "Alternative: Use your insurance app",
        "instruction-app": "Open your health insurer's app and scan this code. The proof is then sent straight to us.",
        "staff-line": "For the practice team: {{address}}",
        "staff-line-practice": "For the practice team: {{name}} · {{address}}",
        "alternative-app": "You can also request the proof with your health insurer's app: open the app and scan this code."
      },
      "register-basics": {
        "title": "Personal Information",
        "subtitle": "Please enter your details.",
        "family-name": "Last name",
        "given-name": "First name",
        "dob": "Date of birth",
        "gender": "Gender",
        "insurance-type": "Insurance type",
        "insurer-name": "Name of your insurance",
        "insurer-name-placeholder": "e.g. Debeka, DKV, Allianz...",
        "gender-required": "Please choose one option."
      },
      "register-insurer": {
        "title": "Health Insurance",
        "subtitle": "Please select your health insurance.",
        "search-placeholder": "Search insurance..."
      },
      "register-details": {
        "title": "Summary",
        "subtitle": "Please review your information.",
        "create": "Complete registration",
        "missing-data": "Please fill in all required fields.",
        "create-error": "Registration failed. Please try again.",
        "policy-number": "Policy number (optional)",
        "policy-number-placeholder": "Your policy number",
        "create-v2": "Finish sign-in",
        "policy-number-hint": "You will find the number on your insurance card."
      },
      "diff-review": {
        "eyebrow-chip": "Review",
        "eyebrow": "Check-in · card data",
        "title": "Data Comparison",
        "subtitle": "Differences were found between your card data and our records.",
        "col-current": "Current record",
        "col-new": "New from card",
        "new-badge": "new",
        "field-fallback": "Field",
        "note": "Updated data helps us bill correctly and reach you in an emergency.",
        "comparison-placeholder": "Comparison will be shown here",
        "confirm": "Confirm changes",
        "apply-error": "The data could not be applied. Please try again.",
        "retry": "Try again",
        "skip": "Continue anyway",
        "no-changes": "No changes found",
        "title-v2": "Your details have changed",
        "subtitle-v2": "Your card has newer details. Shall we use them?",
        "confirm-v2": "Use and sign in",
        "keep": "Sign in without changes",
        "col-current-v2": "Before",
        "col-new-v2": "New from the card",
        "value-yes": "Yes",
        "value-no": "No"
      },
      "insurance-selection": {
        "title": "Insurance Type",
        "subtitle": "Please select your insurance type.",
        "gkv": "Statutory insured",
        "gkv-description": "Member of a statutory health insurance.",
        "pkv": "Private or self-pay",
        "pkv-description": "Privately insured or self-pay.",
        "pkv-description-v2": "Private health insurance, or you pay yourself."
      },
      "eeb-request": {
        "title": "Request recorded",
        "subtitle": "You can finish checking in. The reply from {{insurer}} will arrive at the practice later.",
        "verifying": "Your request has been accepted for immediate processing.",
        "success": "Your request has been securely handed to the practice team.",
        "error": "The request confirmation is not available.",
        "try-alternative": "Alternative method",
        "kim-load-error": "The practice KIM address could not be loaded.",
        "kim-label": "Practice · KIM",
        "non-blocking-note": "This does not yet confirm receipt by your health insurer or your insurance status.",
        "auto-continue": "Continuing automatically in {{seconds}} seconds.",
        "unavailable-title": "Something went wrong",
        "unavailable-v2": "Your request to the health insurer could not be recorded.",
        "unavailable-body": "You can have the proof sent with your health insurer's app, or sort it out at reception.",
        "use-app": "Use the app",
        "at-reception": "Sort it out at reception"
      },
      "self-pay": {
        "title": "Self-Pay",
        "subtitle": "You will be treated as a self-pay patient.",
        "info": "Please note that you will be responsible for the treatment costs.",
        "confirm": "Understood",
        "title-v2": "You pay yourself",
        "subtitle-v2": "You pay for the treatment yourself.",
        "insured-after-all": "I am insured after all"
      },
      "done": {
        "title": "Done!",
        "subtitle": "Your check-in is complete.",
        "finish": "Finish",
        "done-label": "Done",
        "error-label": "Notice",
        "eyebrow": "Check-in · complete",
        "queue-label": "Waiting room",
        "queue-title": "Please take a seat",
        "queue-meta": "We will call you personally.",
        "success-title": "Check-in successful!",
        "success-subtitle": "Please take a seat in the waiting room. You will be called.",
        "auto-redirect": "You will be redirected to the start page shortly...",
        "auto-redirect-countdown": "Returning to start in {{seconds}} seconds...",
        "card-expired-title": "Card expired",
        "card-expired-subtitle": "Your insurance card has expired.",
        "card-expired-info": "Please contact staff for assistance.",
        "back-to-start": "Back to start",
        "anamnesis-title": "Complete medical history form",
        "anamnesis-description": "Scan the QR code to fill out your medical history form conveniently on your smartphone.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "You are signed in",
        "card-expired-info-v2": "Please ask at reception."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Check your details",
          "balance-prefix": "When saving:",
          "balance-direct-v2": "Saved right away: {{count}}",
          "balance-reception-v2": "Checked by reception: {{count}}",
          "chip-reception-v2": "Changes are checked by our reception",
          "chip-changed": "Changed: {{count}}",
          "remove": "Remove",
          "example-email": "e.g. name@example.com",
          "example-phone": "e.g. 0171 1234567",
          "intro-v2": "Your sign-in is complete. Are these details still correct? Checking is optional.",
          "auto-hide": "Shown values are hidden again after a short time."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "We have passed this detail on to reception.",
          "banner-done-v2": "Thank you! We have received your details.",
          "footer-v2": "All other details stay as they are."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "For privacy reasons we have closed the display. Your sign-in is still complete. You can tell reception about changes at any time."
        }
      },
      "progress": {
        "identify": "Sign in",
        "insurance": "Insurance",
        "done": "Done"
      },
      "dob-format-hint": "For example 01.10.1980",
      "dob-required": "Please enter your date of birth.",
      "insurance-label": {
        "GKV": "Statutory insurance",
        "PKV": "Private insurance",
        "SELFPAY": "Paying yourself"
      }
    },
    "emergency": {
      "title": "Acute Emergency!",
      "label": "Emergency",
      "subtitle": "This alert is audible locally only and has not summoned help. For acute or potentially life-threatening emergencies, call 112.",
      "call-emergency": "Call Emergency Services (112)",
      "stop-sound": "Stop sound",
      "play-sound": "Play sound",
      "back-to-start": "Back to start",
      "headline": "Please speak to the staff at the reception immediately. If life is in danger, call 112."
    },
    "help-reception": "Reception help",
    "help-reception-toast": "Please contact reception. We are happy to help.",
    "language-entry": {
      "title": "Choose your language"
    },
    "loading": "Loading…",
    "step-progress-label": "Progress",
    "step-progress-phase": "Section {{current}} of {{total}}: {{phase}}",
    "step-progress-substep": "Part {{current}} of {{total}}",
    "step-progress-complete": "Completed",
    "identification": {
      "title": "Who are you?",
      "lead": "Your health insurance card is the quickest way. You can also search by your name.",
      "lead-card-only": "Please insert your health insurance card into the card reader.",
      "mode-label": "How would you like to sign in?",
      "mode-card": "With card",
      "mode-search": "Search by name",
      "mode-create": "New to the practice",
      "card": {
        "loading": "Preparing the card reader …",
        "checking": "Checking the card reader …",
        "insert-title": "Please insert your health insurance card into the card reader.",
        "insert-detail": "We read your details automatically.",
        "detected": "Card detected",
        "read": "Read card",
        "reading": "Reading card …",
        "reading-hint": "Please leave the card in the reader.",
        "no-terminal-title": "Card reader not available",
        "help-with-search": "Please search by your name or ask at the reception.",
        "help-reception": "Please ask at the reception – we are happy to help.",
        "unreadable-title": "Card detected, but it cannot be read",
        "error-title": "The card could not be read",
        "not-unique": "We could not match you clearly with this card. Please search by your name or ask at the reception.",
        "no-match": "We found no matching details for this card. Please search by your name or ask at the reception.",
        "without-card": "Continue without card"
      },
      "lookup": {
        "lead": "Please enter your last name and your date of birth.",
        "first-name": "First name",
        "last-name": "Last name",
        "dob": "Date of birth",
        "dob-hint": "Format: DD.MM.YYYY",
        "search": "Search",
        "confirm": "Yes, that's me",
        "found-title": "We found you",
        "found-body": "Please confirm that this is you.",
        "first-name-needed-title": "Please add your first name",
        "first-name-needed-body": "So we can find you clearly. Then tap “Search”.",
        "ambiguous-title": "We could not find you clearly",
        "ambiguous-body": "Please ask at the reception – we are happy to help.",
        "not-found-title": "No matching details found",
        "not-found-body": "Please check what you entered.",
        "error-title": "Search is not possible right now",
        "error-body": "Please try again or ask at the reception."
      },
      "create": {
        "insurance-question": "How are you insured?",
        "insurance-required": "Please choose how you are insured.",
        "error-title": "Your details could not be saved",
        "error-body": "Please try again or ask at the reception."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Enable FrontDesk+ first",
      "subtitle": "FrontDesk+ must be activated in your practice software.",
      "step1": "Order it in SolStore (or ask your Doc-Cirrus partner to order it for you).",
      "step2": "After activation, enable it in inSuite under “inSuite Sols” (administrator rights required).",
      "step3": "Open Bridge management → “Add device”.",
      "cta": "All done — continue"
    },
    "welcome": {
      "title": "Add this device to the practice",
      "scan": "Scan the code",
      "prepare-link": "No code in inSuite?",
      "language": "Language"
    },
    "scan": {
      "requesting": "Requesting camera access…",
      "scanning": "Point the camera at the code",
      "paste": "Paste instead",
      "manual-title": "Connect manually",
      "manual-description": "If the QR code is unavailable, copy the connection details from Bridge management.",
      "address-label": "Bridge address",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Enter SOLTOKEN",
      "manual-submit": "Use connection details",
      "error-title": "Code not recognized",
      "camera-denied-title": "Camera access denied",
      "camera-denied-hint": "Please allow camera access in settings and try again.",
      "retry": "Try again"
    },
    "preflight": {
      "title": "Setting up",
      "all-green": "All checks passed",
      "practice": "Practice",
      "device-name": "Device name",
      "device-name-placeholder": "e.g. Reception 1",
      "card-reader": "Card reader",
      "pin": "New PIN",
      "pin-placeholder": "Four-digit PIN",
      "finish": "Finish",
      "recheck": "Check again",
      "diagnosis": "Diagnosis ID",
      "checklist-error": "The Bridge rejected the connection or cannot be reached. Check the SOLTOKEN and Bridge address.",
      "checklist-retry": "Check again",
      "edit-token": "Change SOLTOKEN",
      "rescan": "Scan code again"
    },
    "persisting": "Saving setup …",
    "success": {
      "title": "Device added",
      "detail": "The device has just appeared on the practice PC.",
      "starting": "Patient mode is starting…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Connection to the practice software",
        "fix": "Bridge Check connection and server address."
      },
      "missing_insuite_url": {
        "label": "inSuite address",
        "fix": "Scan the QR code again - the address is missing."
      },
      "missing_server_token": {
        "label": "Server token",
        "fix": "Scan the QR code again - the token is missing."
      },
      "missing_gateway_session": {
        "label": "Gateway session",
        "fix": "Log in again — the session is missing."
      },
      "missing_gateway_enrollment": {
        "label": "Device registration",
        "fix": "Register the device on the Gateway."
      },
      "gateway_not_ready": {
        "label": "Gateway readiness",
        "fix": "Wait for the Gateway to complete the setup."
      },
      "token_verification_failed": {
        "label": "Token check",
        "fix": "Check server token or Bridge connection."
      },
      "session_expired": {
        "label": "Session",
        "fix": "The session has expired — log in again."
      },
      "device_revoked": {
        "label": "Device status",
        "fix": "This device has been blocked. Contact your practice."
      },
      "missing_practice_name": {
        "label": "Practice name",
        "fix": "The practice name could not be loaded from inSuite."
      },
      "missing_device_name": {
        "label": "Device name",
        "fix": "Please enter a device name."
      },
      "telematik_unavailable": {
        "label": "Telematics infrastructure",
        "fix": "Optional — card check remains possible as soon as the TI is available."
      },
      "selected_card_reader_unavailable": {
        "label": "Card reader",
        "fix": "Optional — select or connect a card reader."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Optional — insert the medical practice credential card (SMC-B)."
      }
    },
    "token": {
      "title": "Enter SOLTOKEN",
      "description": "For security reasons the QR code does not contain the SOLTOKEN. Copy it in inSuite under Sol-Aktivierung (FrontDesk+) and paste it here.",
      "submit": "Continue",
      "rescan": "Scan code again"
    }
  }
}
